module.exports = __webpack_public_path__ + "static/media/chevron-down.3c3b9092.svg";